import React from 'react';
import {
  Container,
  Typography,
  Box,
  Paper,
} from '@mui/material';

function PrivacyPolicy() {
  return (
    <Container maxWidth="md" sx={{ py: 8 }}>
      <Paper elevation={0} sx={{ p: 4 }}>
        <Typography variant="h4" gutterBottom>
          Privacy Policy
        </Typography>
        <Typography variant="body1" paragraph>
          Last updated: {new Date().toLocaleDateString()}
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
          1. Introduction
        </Typography>
        <Typography variant="body1" paragraph>
          Lifetime Timer is committed to protecting your privacy. This Privacy Policy explains how we handle your data when you use our application.
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
          2. Data Collection and Storage
        </Typography>
        <Typography variant="body1" paragraph>
          Lifetime Timer is designed to work completely offline. All data, including your birth date and life expectancy settings, is stored locally on your device. We do not collect, transmit, or store any personal information on our servers.
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
          3. Widget Data
        </Typography>
        <Typography variant="body1" paragraph>
          The home screen widgets display information based on your local settings. This data remains on your device and is not shared with any external services.
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
          4. Third-Party Services
        </Typography>
        <Typography variant="body1" paragraph>
          Lifetime Timer does not integrate with any third-party services or analytics platforms. The app functions entirely within your device's ecosystem.
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
          5. Data Deletion
        </Typography>
        <Typography variant="body1" paragraph>
          Since all data is stored locally on your device, you can delete all app data by uninstalling the application. This will remove all stored preferences and settings.
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
          6. Children's Privacy
        </Typography>
        <Typography variant="body1" paragraph>
          Lifetime Timer is not directed at children under 13. We do not knowingly collect personal information from children under 13.
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
          7. Changes to This Policy
        </Typography>
        <Typography variant="body1" paragraph>
          We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
          8. Contact Us
        </Typography>
        <Typography variant="body1" paragraph>
          If you have any questions about this Privacy Policy, please contact us through the feedback form in the app or on our website.
        </Typography>

        <Box sx={{ mt: 6, pt: 4, borderTop: 1, borderColor: 'divider' }}>
          <Typography variant="body2" color="text.secondary">
            © {new Date().getFullYear()} Lifetime Timer. All rights reserved.
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
}

export default PrivacyPolicy; 